
import axios from '@/axios.js'

var api = {
  // 搜索热词
  searchHotWords(params) {
    return axios.get('/api/meituan/header/searchHotWords.json', params)
  },
  // 搜索列表
  getSearchList() {
    return axios.get('/api/meituan/header/search.json')
  },
  // main区域banner左侧菜单列表
  getMenuList() {
    return axios.get('/api/meituan/index/nav.json')
  },
  // 主页各板块hover关键字下的列表数据
  resultsByKeywords() {
    return axios.get('/api/meituan/index/resultsByKeywords.json')
  },
  // 产品列表
  getProductsList() {
    return axios.get('/api/meituan/list/goodsList.json')
  },
  // 热门城市
  getHotCity() {
    return axios.get('/api/meituan/city/hot.json')
  },
  // 最近搜索城市
  getRecentCity() {
    return axios.get('/api/meituan/city/recents.json')
  },
  //省份列表
  getProvinceList() {
    return axios.get('/api/meituan/city/province.json')
  },
  // 获取当前地理位置
  getCurPosition() {
    // return axios.get('/api/meituan/city/getPosition.json')
    // 实例拦截响应
    const instance = axios.create({
      baseURL: 'https://open.duyiedu.com',
    });
    instance.interceptors.response.use(response => {
      // console.log("CurPosition", response.data.data);
      response.data.data = {
        "id": 20,
        "name": "湖北省",
        "pinyin": "hubeisheng",
        "acronym": "hb",
        "rank": "H",
        "firstChar": "h",
        "nearCity": [{
          "id": 20000,
          "name": "黄石市",
          "pinyin": "huagnshi",
          "acronym": "hs",
        },
        {
          "id": 300000,
          "name": "大冶市",
          "pinyin": "dayeshi",
          "acronym": "dys",
        },
        {
          "id": 400000,
          "name": "水瓶区",
          "pinyin": "shuipingqu",
          "acronym": "spq",
        }]
      }
      return response;
    });
    return instance.get('/api/meituan/city/getPosition.json', {
      params: {
        appkey: '136975643_1581253537321'
      }
    });
  },
  // 获取城市列表
  getCityList() {
    return axios.get('/api/meituan/city/cityList.json')
  },
  // 注册
  register(params) {
    return axios.get('/api/meituan/register', params)
  },
  // 登录
  login(params) {
    return axios.get('/api/meituan/login', params)
  },
}


export default api
